import { render, staticRenderFns } from "./secondData.vue?vue&type=template&id=4261b131&scoped=true&"
import script from "./secondData.vue?vue&type=script&lang=js&"
export * from "./secondData.vue?vue&type=script&lang=js&"
import style0 from "./secondData.vue?vue&type=style&index=0&id=4261b131&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4261b131",
  null
  
)

export default component.exports